var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dash',{attrs:{"icon":"fa fa-thumbs-down","titulo":"ENTREGAS COM ERRO NO COMPROMETIMENTO","qtd":_vm.qtd,"loading":_vm.loading,"color":"#ff4040"}})}
var staticRenderFns = []

export { render, staticRenderFns }